import createLucideIcon from '../createLucideIcon';

const WholeWord = createLucideIcon('WholeWord', [
  ['circle', { cx: '17', cy: '12', r: '3', key: 'gl7c2s' }],
  ['line', { x1: '14', x2: '14', y1: '7', y2: '15', key: '111rms' }],
  ['circle', { cx: '7', cy: '12', r: '3', key: '12clwm' }],
  ['line', { x1: '10', x2: '10', y1: '9', y2: '15', key: '1o5uit' }],
  ['polyline', { points: '22,17 22,19 2,19 2,17', key: 'w01tig' }],
]);

export default WholeWord;
